import { Controller } from "@hotwired/stimulus"

// Opent het "Snel loggen"-paneel (<dialog>). Sluit bij een klik op de
// achtergrond, met Escape (native) en vóór Turbo de pagina cachet.
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.beforeCache = () => this.close()
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
  }

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
